import { render, staticRenderFns } from "./Scene10.vue?vue&type=template&id=9237b34c&"
import script from "./Scene10.vue?vue&type=script&lang=js&"
export * from "./Scene10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports